export default __webpack_public_path__ + "static/media/text_button.c7f5cd82.png";